import { useQuery } from "@tanstack/react-query";
import {
  aggregateRequests,
  type AggregateRequestsParams,
  type RequestAggregateRowDto,
} from "@/api/endpoints";

export function useRequestAggregateQuery(params: AggregateRequestsParams, enabled = true) {
  return useQuery<RequestAggregateRowDto[]>({
    queryKey: ["requests", "aggregate", params],
    queryFn: () => aggregateRequests(params),
    staleTime: 60_000,
    enabled: enabled && params.groupBy.length > 0,
    // Conditional placeholder: keep the previous result while a new query is in flight ONLY when
    // the groupBy shape is unchanged. If the user added/removed/reordered a group-by pill, the old
    // rows' groupValues dict no longer matches the new column set — rendering them produces blank
    // cells under the new column and unstable React keys (perceived as duplicate rows). For
    // groupBy changes we surrender to a brief loading state; filter-only changes still avoid flicker.
    placeholderData: (prev, prevQuery) => {
      if (!prev) return undefined;
      const prevParams = prevQuery?.queryKey?.[2] as AggregateRequestsParams | undefined;
      const sameShape =
        !!prevParams &&
        prevParams.groupBy.length === params.groupBy.length &&
        prevParams.groupBy.every((k, i) => k === params.groupBy[i]);
      return sameShape ? prev : undefined;
    },
  });
}
